// ro-only-numbers.js
; (() => {
    document.querySelectorAll('.ro-only-numbers').forEach(numeric => {
        numeric.addEventListener('keydown', event => {
            const { keyCode } = event
            // console.log(keyCode)
            const allowed = [
                48, 49, 50, 51, 52, 53, 54, 55, 56, 57,
                96, 97, 98, 99, 100, 101, 102, 103, 104, 105,
                9, // tab
                8, // backspace
                46, // delete
                13, // enter
                37, 39, // arrow left and right
                110, // dot
            ]

            if (!allowed.includes(keyCode)) {
                event.preventDefault()
            }

        })
    })
})();